<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="map01">
<div class="chapterHead">
<h2 class="chapterTitle0"><span class="xrefInternal"><a href="#/contents#map_01">Map</a></span></h2></div>
<div class="chapterBody">
<a id="page11"></a>
<p class="colophon"><img alt="img" src="map.jpg"/></p>
<a id="page12"></a>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map01.vue?04b03cc9